import {
  CreateOrganisationRequest,
  OrganisationOnboardingResponse,
} from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface, OrganisationOnboarding } from '../../types/global';
import BaseAdapter from './baseAdapter';

export interface CreateOrganisationPayload {
  samlProviderName: string | null;
  displayName: string;
  calculatorOrgId: number | null;
  emailDomains: string[];
  liftDataIds: number[];
  isCampaignEnabled: boolean;
  metadataUrl: string | null;
  xmlMetadata: string | null;
  customClaimClients: string[];
}

export default class OnboardOrganisation extends BaseAdapter<OrganisationOnboardingResponse> implements AdapterInterface {
  rawResponse: OrganisationOnboardingResponse;

  modifiedRequest: CreateOrganisationRequest;

  async adaptResponse(payload: CreateOrganisationPayload): Promise<OrganisationOnboarding> {
    const formattedRequest = this.adaptRequest(payload);
    await this.fetchApiResponse('/api/admin/organisation/onboard', HTTPMethod.Post, formattedRequest);
    return this.displayResponse();
  }

  displayResponse(): OrganisationOnboarding {
    const {
      saml_provider_name: samlProviderName, display_name: displayName, app_client_id: appClientId, is_campaign_enabled: isCampaignEnabled, provider_type: providerType,
    } = this.rawResponse;
    return {
      samlProviderName,
      displayName,
      appClientId,
      providerType,
      isCampaignEnabled,
    };
  }

  adaptRequest(payload: CreateOrganisationPayload): CreateOrganisationRequest {
    this.modifiedRequest = {
      display_name: payload.displayName,
      calculator_org_id: payload.calculatorOrgId,
      email_domains: payload.emailDomains,
      lift_data_ids: payload.liftDataIds,
      is_campaign_enabled: payload.isCampaignEnabled,
      ...(payload.samlProviderName !== null && {
        sso_configuration: {
          saml_provider_name: payload.samlProviderName,
          metadata_url: payload.metadataUrl,
          xml_metadata: payload.xmlMetadata,
          custom_claim_clients: payload.customClaimClients,
        },
      }),
    };
    return this.modifiedRequest;
  }
}
